import styled from "styled-components/macro";
import { COLORES } from "../../constants";

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${COLORES.DEFAULT_MODULE_BACKGROUND};
  margin-bottom: 2rem;
  border-radius: 0.25rem;
`;

export const Header = styled.div`
  width: 100%;
  height: 2rem;
  color: ${COLORES.DEFAULT_MODULE_HEADER_FONT};
  background-color: ${COLORES.DEFAULT_MODULE_HEADER_BACKGROUND};
  font-weight: bold;
  border-radius: 0.25rem 0.25rem 0 0;

  p {
    line-height: 2rem;
    padding-left: 1rem;
  }
`;

export const Content = styled.form`
  table {
    width: 100%;
    table-layout:fixed;
    border-collapse: collapse;

    thead {
      tr {
        height: 1.5rem;
        font-weight: bold;
      }
      th {
        text-align: left;
        padding-left: 0.5rem;
      }
    }

    tbody {
      tr {
        height: 1.5rem;
      }
      td {
        padding-left: 0.5rem;
                  text-overflow: clip;
          white-space: nowrap;
          overflow: hidden;
      }
    }
  }
`;

export const TrColumnTitles = styled.tr`
  background-color: ${COLORES.HEADER_ROW_BACKGROUND};
  
  th:nth-child(1),
  th:nth-child(2) {
    width: 15%;
  }
  th:nth-child(3),
  th:nth-child(4),
  th:nth-child(5) {
    width: 7%;
  }
  th:nth-child(6) {
    width: 4%;
  }
  th:nth-child(7),
  th:nth-child(8),
  th:nth-child(9) {
    width: 10%;
  }
  th:nth-child(10) {
    width: 4%;
  }
  th:nth-child(11) {
    width:32%
  }
   th {
    text-align: left;
    padding-left: 0.5rem;
    text-overflow: clip;
    white-space: nowrap;
    overflow: hidden;
  }
`;
